module.exports = __webpack_public_path__ + "img/2.2.TN.7254e210.png";